import { EditableFence } from "./types";

type InvalidFencesPanelProps = {
  fences: EditableFence[];
  savingId: string | null;
  onDelete: (fence: EditableFence) => void;
};

/**
 * Fences the server returned without a real position (0,0 or fewer than three
 * points). They can't be drawn or edited, only removed.
 */
const InvalidFencesPanel = ({ fences, savingId, onDelete }: InvalidFencesPanelProps) => {
  if (fences.length === 0) return null;

  return (
    <section className="rounded-lg border-2 border-amber-300 bg-amber-50 p-3 shadow" role="alert">
      <h5 className="text-sm font-bold text-amber-900">
        {fences.length} fence{fences.length === 1 ? "" : "s"} with invalid coordinates
      </h5>
      <p className="mt-1 text-xs text-amber-800">
        These were saved without a usable position, so they are hidden from the map.
        Delete them and draw replacements.
      </p>
      <ul className="mt-2 space-y-1">
        {fences.map((fence) => (
          <li key={fence.locationId} className="flex items-center justify-between gap-2 rounded bg-white px-2 py-1 text-sm">
            <span className="truncate">{fence.name || <span className="italic text-gray-400">Unnamed fence</span>}</span>
            <button
              type="button"
              onClick={() => onDelete(fence)}
              disabled={savingId === fence.locationId}
              className="shrink-0 rounded bg-red-500 px-2 py-1 text-xs font-bold text-white hover:bg-red-700 disabled:opacity-50"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default InvalidFencesPanel;
